import axios from '@/app/plugins/Axios'

export default new class CaixaService {

  listar(data) {
    if (data) data = '?data=' + data;
    else data = '';
    
    return axios.get('caixa' + data)
      .then(response => response.data);
  }

  abrir(id) {
    return axios.get('/caixa/' + id)
      .then(response => response.data);
  }

  salvar(caixa) {
    return axios.post('/caixa', caixa)
      .then(response => response.data);
  }

  salvarSangria(caixa) {
    return axios.post('/caixa/sangria', caixa)
      .then(response => response.data);
  }

  atualizar(caixa) {
    return axios.put('/caixa/'+ caixa.id, caixa)
      .then(response => response.data)
  }

  excluir(id) {
    return axios.delete('/caixa/' + id)
      .then(response => response.data);
  }

  impressaoTermica(caixa) {
    return axios.post(`/caixa/impressao-termica`, caixa)
      .then((response) => response.data);
  }
}
